import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import AccordionComponent from '../custom-post-types/accordion';

const TabPageComponent = ({ tabPages, defaultActiveTab, productsGroupedByCategories }) => {
  return (
    <Tabs defaultActiveKey={defaultActiveTab}>
      {tabPages.map((tabPage, tabIndex) => {
        const hasContent = !!tabPage?.content || false;
        const hasAccordionItems = !!tabPage?.accordionItems?.length > 0 || false;

        if (tabPage.slug != 'datasheets') {
          return (
            <Tab eventKey={tabPage.slug} title={tabPage.title} key={tabPage.slug}>
              <div className="bg-white p-4">
                {hasContent && <section dangerouslySetInnerHTML={{ __html:  tabPage.content }} itemProp="tabContent" />}

                {hasAccordionItems && <AccordionComponent accordionItems={tabPage.accordionItems} />}
              </div>
            </Tab>
          );
        } else {
          // TODO: REMOVE SPECIAL TREATMENT FOR THE DATASHEETS PAGE/TAB
          return (
            <Tab eventKey="datasheets" title="Datasheets" key="datasheets">
            <div className="bg-white p-4">
              <Accordion flush>
                {Object.entries(productsGroupedByCategories).map((kv, index) => {
                  const category = kv[0];
                  const products = kv[1];
                  return (
                    <Accordion.Item eventKey={index}>
                      <Accordion.Header className="accordion-header-title">
                        {category}
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="container">
                          <div className="row">
                            <ul>
                              {products.map(product => {
                                return (
                                  <li>
                                    {product?.productDetails?.datasheet?.mediaItemUrl != null
                                      ? <a href={product?.productDetails?.datasheet?.mediaItemUrl}>{product.title}</a>
                                      : <s>{product?.title}</s>
                                    }
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  )
                })}
              </Accordion>
            </div>
          </Tab>
          );
        }
      })}
    </Tabs>
  );
};

export default TabPageComponent;
